import React from "react";
import { Icon } from "@iconify/react";
// import heading from "../../assets/images/roadmap-heading-trv.png";

const RoadMap = () => {
  return (
    <div className="roadmap_bg">
      {/* <img
        className="w-[67%] mx-auto mb-[30px] pt-[150px]"
        src={heading}
        alt=""
      /> */}
      <div className="text-center text-white w-[67%] mx-auto font-semibold">
        <p className="leading-[30px]">
          The Red Village is a dark and brutal world, a place where only the
          strong, the courageous, and the cunning survive. Currently under
          development in conjunction with award-winning game studio Blowfish
          Studios, <br /> The Red Village is a dark-fantasy franchise that mixes
          savagery and humour, <br /> creating a landscape where almost anything
          goes.
        </p>
      </div>
      <h1 className="text-center text-white mt-[25px] mb-[35px] text-[50px]">
        Development
      </h1>
      <div className="flex flex-row justify-center gap-4 text-white">
        <div className="p-3 h-[160px] rounded-[10px] w-[450px] card">
          <div className="font-bold italic">Tournaments (beta)</div>
          <p>
            <span className="italic leading-[30px]">Tournaments</span>{" "}
            autobattler currently live and playable (in beta).
          </p>
        </div>
        <div className="p-3 h-[160px] rounded-[10px] w-[450px] leading-[27px] card">
          <div className="font-bold">Under Development</div>
          <p className="text-[15px]">
            <span className="italic">Darklands</span> is currently under
            development. <br /> Darklands is the second instalment in The Red
            Village franchise. <br /> It will be available on PC in 2024, with
            further platform <br /> expansions possible.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RoadMap;
